import { DateString, List, PriceWithCurrency, Table, Tag, useMediaQueryContext, } from '@fourthwall/components';
import React from 'react';
import { tagsAppearances } from '../../consts';
import { PayoutsHistoryListItem } from '../PayoutsHistoryListItem/PayoutsHistoryListItem';
export const headers = [
    {
        id: 'date',
        label: 'Date',
        render: ({ date }) => React.createElement(DateString, { date: date, format: "MMM DD, YYYY" }),
        width: 1,
        minHeight: 48,
    },
    {
        id: 'amount',
        label: 'Amount',
        render: ({ transferAmount, payoutAmount }) => (React.createElement("div", null,
            React.createElement(PriceWithCurrency, { ...transferAmount }),
            payoutAmount && payoutAmount.currency !== transferAmount.currency ? (React.createElement("div", null,
                "(",
                React.createElement(PriceWithCurrency, { ...payoutAmount }),
                ")")) : null)),
        width: 1.2,
        minHeight: 48,
    },
    {
        id: 'paidTo',
        label: 'Paid to',
        render: ({ paidTo }) => paidTo,
        width: 1,
        minHeight: 48,
    },
    {
        id: 'status',
        label: 'Status',
        render: ({ status }) => React.createElement(Tag, { label: status, appearance: tagsAppearances[status] }),
        width: 1,
        minHeight: 48,
    },
];
export const PayoutsHistoryData = ({ data, isLoading }) => {
    const media = useMediaQueryContext();
    const emptyMessage = 'There are no payouts yet.';
    if (!media.tablet) {
        return (React.createElement(List, { data: data, isLoading: isLoading, emptyComponent: emptyMessage, renderItem: (payoutHistoryItem) => (React.createElement(PayoutsHistoryListItem, { payoutHistoryItem: payoutHistoryItem })) }));
    }
    return (React.createElement(Table, { headers: headers, data: data, emptyMessage: emptyMessage, isLoading: isLoading, minWidth: 0 }));
};
